// source: api/dashboard-admin/v1/tier_message.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.dashboard_admin.Tier', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard_admin.Tier = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard_admin.Tier, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard_admin.Tier.displayName = 'proto.dashboard_admin.Tier';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard_admin.Tier.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard_admin.Tier.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard_admin.Tier} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard_admin.Tier.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    maskRisk: jspb.Message.getFieldWithDefault(msg, 3, 0),
    maskSound: jspb.Message.getFieldWithDefault(msg, 4, 0),
    maskVibration: jspb.Message.getFieldWithDefault(msg, 5, 0),
    notificationTimeoutMinutes: jspb.Message.getFieldWithDefault(msg, 6, 0),
    showHazardLifting: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    showHazardTwisting: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    showHazardStatic: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    showHazardIntensity: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    showHazardRepetition: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    showHazardPushingpulling: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    showHazardStaticarmelevation: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    showHazardRepetitivearmmovements: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    showHazardOverexertion: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    showHazardArmElevation: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
    firstDayNotificationsDisabled: jspb.Message.getBooleanFieldWithDefault(msg, 17, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard_admin.Tier}
 */
proto.dashboard_admin.Tier.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard_admin.Tier;
  return proto.dashboard_admin.Tier.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard_admin.Tier} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard_admin.Tier}
 */
proto.dashboard_admin.Tier.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaskRisk(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaskSound(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaskVibration(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNotificationTimeoutMinutes(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowHazardLifting(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowHazardTwisting(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowHazardStatic(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowHazardIntensity(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowHazardRepetition(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowHazardPushingpulling(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowHazardStaticarmelevation(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowHazardRepetitivearmmovements(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowHazardOverexertion(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowHazardArmElevation(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFirstDayNotificationsDisabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard_admin.Tier.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard_admin.Tier.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard_admin.Tier} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard_admin.Tier.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMaskRisk();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getMaskSound();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getMaskVibration();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getNotificationTimeoutMinutes();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getShowHazardLifting();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getShowHazardTwisting();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getShowHazardStatic();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getShowHazardIntensity();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getShowHazardRepetition();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getShowHazardPushingpulling();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getShowHazardStaticarmelevation();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getShowHazardRepetitivearmmovements();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getShowHazardOverexertion();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getShowHazardArmElevation();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getFirstDayNotificationsDisabled();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.dashboard_admin.Tier.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard_admin.Tier} returns this
 */
proto.dashboard_admin.Tier.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.dashboard_admin.Tier.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard_admin.Tier} returns this
 */
proto.dashboard_admin.Tier.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 mask_risk = 3;
 * @return {number}
 */
proto.dashboard_admin.Tier.prototype.getMaskRisk = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard_admin.Tier} returns this
 */
proto.dashboard_admin.Tier.prototype.setMaskRisk = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 mask_sound = 4;
 * @return {number}
 */
proto.dashboard_admin.Tier.prototype.getMaskSound = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard_admin.Tier} returns this
 */
proto.dashboard_admin.Tier.prototype.setMaskSound = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 mask_vibration = 5;
 * @return {number}
 */
proto.dashboard_admin.Tier.prototype.getMaskVibration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard_admin.Tier} returns this
 */
proto.dashboard_admin.Tier.prototype.setMaskVibration = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 notification_timeout_minutes = 6;
 * @return {number}
 */
proto.dashboard_admin.Tier.prototype.getNotificationTimeoutMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard_admin.Tier} returns this
 */
proto.dashboard_admin.Tier.prototype.setNotificationTimeoutMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bool show_hazard_lifting = 7;
 * @return {boolean}
 */
proto.dashboard_admin.Tier.prototype.getShowHazardLifting = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dashboard_admin.Tier} returns this
 */
proto.dashboard_admin.Tier.prototype.setShowHazardLifting = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool show_hazard_twisting = 8;
 * @return {boolean}
 */
proto.dashboard_admin.Tier.prototype.getShowHazardTwisting = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dashboard_admin.Tier} returns this
 */
proto.dashboard_admin.Tier.prototype.setShowHazardTwisting = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional bool show_hazard_static = 9;
 * @return {boolean}
 */
proto.dashboard_admin.Tier.prototype.getShowHazardStatic = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dashboard_admin.Tier} returns this
 */
proto.dashboard_admin.Tier.prototype.setShowHazardStatic = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool show_hazard_intensity = 10;
 * @return {boolean}
 */
proto.dashboard_admin.Tier.prototype.getShowHazardIntensity = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dashboard_admin.Tier} returns this
 */
proto.dashboard_admin.Tier.prototype.setShowHazardIntensity = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool show_hazard_repetition = 11;
 * @return {boolean}
 */
proto.dashboard_admin.Tier.prototype.getShowHazardRepetition = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dashboard_admin.Tier} returns this
 */
proto.dashboard_admin.Tier.prototype.setShowHazardRepetition = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool show_hazard_pushingPulling = 12;
 * @return {boolean}
 */
proto.dashboard_admin.Tier.prototype.getShowHazardPushingpulling = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dashboard_admin.Tier} returns this
 */
proto.dashboard_admin.Tier.prototype.setShowHazardPushingpulling = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool show_hazard_staticArmElevation = 13;
 * @return {boolean}
 */
proto.dashboard_admin.Tier.prototype.getShowHazardStaticarmelevation = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dashboard_admin.Tier} returns this
 */
proto.dashboard_admin.Tier.prototype.setShowHazardStaticarmelevation = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional bool show_hazard_repetitiveArmMovements = 14;
 * @return {boolean}
 */
proto.dashboard_admin.Tier.prototype.getShowHazardRepetitivearmmovements = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dashboard_admin.Tier} returns this
 */
proto.dashboard_admin.Tier.prototype.setShowHazardRepetitivearmmovements = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional bool show_hazard_overexertion = 15;
 * @return {boolean}
 */
proto.dashboard_admin.Tier.prototype.getShowHazardOverexertion = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dashboard_admin.Tier} returns this
 */
proto.dashboard_admin.Tier.prototype.setShowHazardOverexertion = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional bool show_hazard_arm_elevation = 16;
 * @return {boolean}
 */
proto.dashboard_admin.Tier.prototype.getShowHazardArmElevation = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dashboard_admin.Tier} returns this
 */
proto.dashboard_admin.Tier.prototype.setShowHazardArmElevation = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional bool first_day_notifications_disabled = 17;
 * @return {boolean}
 */
proto.dashboard_admin.Tier.prototype.getFirstDayNotificationsDisabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dashboard_admin.Tier} returns this
 */
proto.dashboard_admin.Tier.prototype.setFirstDayNotificationsDisabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};


goog.object.extend(exports, proto.dashboard_admin);
